module.exports = __webpack_public_path__ + "static/media/Payment.4bdf4b0d.svg";